"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRepositoryCatalogDataResponseToJSON = exports.GetRepositoryCatalogDataResponseFromJSONTyped = exports.GetRepositoryCatalogDataResponseFromJSON = exports.instanceOfGetRepositoryCatalogDataResponse = void 0;
/* tslint:disable */
/* eslint-disable */
/**
 * ECR Public gallery
 * This is an API used in Spencer gallery API Gateway to proxy request to ECR Public.
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
const runtime_1 = require("../runtime");
const RepositoryCatalogData_1 = require("./RepositoryCatalogData");
const RepositoryInsightData_1 = require("./RepositoryInsightData");
/**
 * Check if a given object implements the GetRepositoryCatalogDataResponse interface.
 */
function instanceOfGetRepositoryCatalogDataResponse(value) {
    let isInstance = true;
    return isInstance;
}
exports.instanceOfGetRepositoryCatalogDataResponse = instanceOfGetRepositoryCatalogDataResponse;
function GetRepositoryCatalogDataResponseFromJSON(json) {
    return GetRepositoryCatalogDataResponseFromJSONTyped(json, false);
}
exports.GetRepositoryCatalogDataResponseFromJSON = GetRepositoryCatalogDataResponseFromJSON;
function GetRepositoryCatalogDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'catalogData': !(0, runtime_1.exists)(json, 'catalogData') ? undefined : (0, RepositoryCatalogData_1.RepositoryCatalogDataFromJSON)(json['catalogData']),
        'insightData': !(0, runtime_1.exists)(json, 'insightData') ? undefined : (0, RepositoryInsightData_1.RepositoryInsightDataFromJSON)(json['insightData']),
    };
}
exports.GetRepositoryCatalogDataResponseFromJSONTyped = GetRepositoryCatalogDataResponseFromJSONTyped;
function GetRepositoryCatalogDataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'catalogData': (0, RepositoryCatalogData_1.RepositoryCatalogDataToJSON)(value.catalogData),
        'insightData': (0, RepositoryInsightData_1.RepositoryInsightDataToJSON)(value.insightData),
    };
}
exports.GetRepositoryCatalogDataResponseToJSON = GetRepositoryCatalogDataResponseToJSON;
